import { Fancybox } from "@fancyapps/ui/src/Fancybox/Fancybox.js";


Fancybox.bind('.fancyboxVideo'); 